export function imprimeSiContiene(aguja, texto, salida) {
  const needle = aguja == null ? '' : String(aguja)
  const baseText = Array.isArray(texto)
    ? texto.filter((v) => v != null && v !== '').join(' ')
    : texto
  const haystack = baseText == null ? '' : String(baseText)

  if (!needle) return ''
  const n = needle.toLowerCase()
  const h = haystack.toLowerCase()
  return h.includes(n) ? (salida == null ? '' : String(salida)) : ''
}
